(function () {
  'use strict';

  // Show the image of a thumbnail in the main frame (+ reset zoom).
  // direction: 'next' | 'prev' plays a short slide-in when coming from a swipe.
  function selectThumb(thumb, direction) {
    document.querySelectorAll('.eclat-product-thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');

    // Keep the active thumbnail visible in the thumbnail strip
    var strip = thumb.closest('.eclat-product-thumbs');
    if (strip && strip.scrollWidth > strip.clientWidth) {
      strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
    }

    var mainImg = document.getElementById('eclat-main-image');
    if (mainImg) {
      mainImg.src = thumb.dataset.mediaSrc;
      var mainWrap = mainImg.closest('.eclat-product-main');
      if (mainWrap) {
        mainWrap.classList.remove('is-zoomed');
        mainImg.style.transform = 'scale(1)';
        mainImg.style.transformOrigin = 'center';
      }
      if (direction) {
        mainImg.classList.remove('eclat-slide-next', 'eclat-slide-prev');
        void mainImg.offsetWidth; // restart the animation
        mainImg.classList.add('eclat-slide-' + direction);
      }
    }
  }

  // Thumbnail click
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.eclat-product-thumb');
    if (thumb) selectThumb(thumb);
  });

  // Swipe left / right on the main photo (touch screens) → next / previous image
  var swipeWrap = document.querySelector('.eclat-product-main');
  if (swipeWrap) {
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var preloaded = false;

    swipeWrap.addEventListener('touchstart', function (e) {
      tracking = e.touches.length === 1 && !swipeWrap.classList.contains('is-zoomed');
      if (!tracking) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;

      // Warm the cache so the next image appears instantly
      if (!preloaded) {
        preloaded = true;
        document.querySelectorAll('.eclat-product-thumb').forEach(function (t) {
          new Image().src = t.dataset.mediaSrc;
        });
      }
    }, { passive: true });

    swipeWrap.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      // Ignore taps and vertical page scrolls
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;

      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.eclat-product-thumb'));
      if (thumbs.length < 2) return;
      var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) current = 0;
      var goNext = dx < 0;
      var target = (current + (goNext ? 1 : -1) + thumbs.length) % thumbs.length;
      selectThumb(thumbs[target], goNext ? 'next' : 'prev');
    }, { passive: true });
  }

  // ==================== LIGHTBOX (click the photo → full screen + zoom) ====================
  var zoomWrap = document.querySelector('.eclat-product-main');
  if (zoomWrap && zoomWrap.dataset.imageZoom !== 'none') {
    var MAX_SCALE = 4;
    var CLICK_SCALE = 2.5;
    var lb = null;
    var lbImg = null;
    var lbStage = null;
    var lbCounter = null;
    var index = 0;
    var scale = 1;
    var tx = 0;
    var ty = 0;
    var lastFocus = null;

    function getSlides() {
      return Array.prototype.map.call(document.querySelectorAll('.eclat-product-thumb'), function (t) {
        return { src: t.dataset.mediaSrc, zoomSrc: t.dataset.zoomSrc || t.dataset.mediaSrc, alt: t.dataset.alt || '' };
      });
    }

    function build() {
      lb = document.createElement('div');
      lb.className = 'eclat-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.hidden = true;
      lb.innerHTML =
        '<div class="eclat-lightbox__stage"><img class="eclat-lightbox__img" alt="" draggable="false"></div>' +
        '<button type="button" class="eclat-lightbox__btn eclat-lightbox__close" aria-label="' + zoomWrap.dataset.labelClose + '">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
        '<button type="button" class="eclat-lightbox__btn eclat-lightbox__arrow eclat-lightbox__arrow--prev" aria-label="' + zoomWrap.dataset.labelPrev + '">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg></button>' +
        '<button type="button" class="eclat-lightbox__btn eclat-lightbox__arrow eclat-lightbox__arrow--next" aria-label="' + zoomWrap.dataset.labelNext + '">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg></button>' +
        '<div class="eclat-lightbox__counter" aria-live="polite"></div>';
      document.body.appendChild(lb);

      lbStage = lb.querySelector('.eclat-lightbox__stage');
      lbImg = lb.querySelector('.eclat-lightbox__img');
      lbCounter = lb.querySelector('.eclat-lightbox__counter');

      lb.querySelector('.eclat-lightbox__close').addEventListener('click', close);
      lb.querySelector('.eclat-lightbox__arrow--prev').addEventListener('click', function () { go(-1); });
      lb.querySelector('.eclat-lightbox__arrow--next').addEventListener('click', function () { go(1); });
      document.addEventListener('keydown', onKey);
      bindMouse();
      bindTouch();
    }

    // ---- transform helpers ----
    function bounds() {
      return { x: (lbStage.clientWidth * (scale - 1)) / 2, y: (lbStage.clientHeight * (scale - 1)) / 2 };
    }
    function clampPan() {
      var b = bounds();
      tx = Math.max(-b.x, Math.min(b.x, tx));
      ty = Math.max(-b.y, Math.min(b.y, ty));
    }
    function apply(animate) {
      lbImg.style.transition = animate ? 'transform 0.25s ease' : 'none';
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      lb.classList.toggle('is-zoomed', scale > 1.01);
    }
    function reset(animate) {
      scale = 1; tx = 0; ty = 0;
      apply(animate);
    }
    // Zoom to `s`, keeping the point (px, py) — relative to the stage centre — under the finger/cursor
    function zoomAt(s, px, py, animate) {
      var ratio = s / scale;
      tx = px - (px - tx) * ratio;
      ty = py - (py - ty) * ratio;
      scale = s;
      clampPan();
      apply(animate);
    }
    function stagePoint(clientX, clientY) {
      var r = lbStage.getBoundingClientRect();
      return { x: clientX - r.left - r.width / 2, y: clientY - r.top - r.height / 2 };
    }

    // ---- open / close / navigate ----
    function show(i, direction) {
      var slides = getSlides();
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      reset(false);
      // Show the already-loaded page image at once, then swap in the sharp one for zooming
      var slide = slides[index];
      lbImg.src = slide.src;
      lbImg.alt = slide.alt;
      if (slide.zoomSrc !== slide.src) {
        var hiRes = new Image();
        var shownIndex = index;
        hiRes.onload = function () {
          if (index === shownIndex && !lb.hidden) lbImg.src = slide.zoomSrc;
        };
        hiRes.src = slide.zoomSrc;
      }
      lbCounter.textContent = slides.length > 1 ? index + 1 + ' / ' + slides.length : '';
      lb.classList.toggle('has-many', slides.length > 1);
      if (direction) {
        lbImg.classList.remove('eclat-slide-next', 'eclat-slide-prev');
        void lbImg.offsetWidth;
        lbImg.classList.add('eclat-slide-' + direction);
      }
    }
    function go(step) {
      show(index + step, step > 0 ? 'next' : 'prev');
    }
    function open() {
      if (!lb) build();
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.eclat-product-thumb'));
      var active = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      lastFocus = document.activeElement;
      show(active < 0 ? 0 : active);
      lb.hidden = false;
      document.documentElement.classList.add('eclat-lightbox-open');
      lb.querySelector('.eclat-lightbox__close').focus({ preventScroll: true });
    }
    function close() {
      lb.hidden = true;
      document.documentElement.classList.remove('eclat-lightbox-open');
      // Keep the page gallery on the image that was last viewed
      var thumbs = document.querySelectorAll('.eclat-product-thumb');
      if (thumbs[index] && !thumbs[index].classList.contains('is-active')) thumbs[index].click();
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }
    function onKey(e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    }

    // ---- mouse: click toggles zoom, moving the mouse pans ----
    function bindMouse() {
      lbStage.addEventListener('click', function (e) {
        if (e.target !== lbImg) { if (scale === 1) close(); return; }
        if (lb.dataset.touch === '1') return; // touch handled separately
        var p = stagePoint(e.clientX, e.clientY);
        if (scale > 1.01) reset(true);
        else zoomAt(CLICK_SCALE, p.x, p.y, true);
      });
      lbStage.addEventListener('mousemove', function (e) {
        if (scale <= 1.01 || lb.dataset.touch === '1') return;
        var r = lbStage.getBoundingClientRect();
        var b = bounds();
        tx = -((e.clientX - r.left) / r.width - 0.5) * 2 * b.x;
        ty = -((e.clientY - r.top) / r.height - 0.5) * 2 * b.y;
        apply(false);
      });
    }

    // ---- touch: pinch zoom, double-tap zoom, drag to pan, swipe to change image ----
    function bindTouch() {
      var start = null;
      var lastTap = 0;

      function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
      function mid(t) { return stagePoint((t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2); }

      lbStage.addEventListener('touchstart', function (e) {
        lb.dataset.touch = '1';
        var t = e.touches;
        if (t.length === 2) {
          start = { pinch: true, d: dist(t), scale: scale, tx: tx, ty: ty, m: mid(t) };
        } else if (t.length === 1) {
          start = { pinch: false, x: t[0].clientX, y: t[0].clientY, tx: tx, ty: ty, moved: false };
        }
      }, { passive: true });

      lbStage.addEventListener('touchmove', function (e) {
        if (!start) return;
        var t = e.touches;
        e.preventDefault();
        if (start.pinch && t.length === 2) {
          var s = Math.max(1, Math.min(MAX_SCALE, (start.scale * dist(t)) / start.d));
          var m = mid(t);
          var ratio = s / start.scale;
          scale = s;
          tx = m.x - (start.m.x - start.tx) * ratio;
          ty = m.y - (start.m.y - start.ty) * ratio;
          clampPan();
          apply(false);
        } else if (!start.pinch && t.length === 1) {
          var dx = t[0].clientX - start.x;
          var dy = t[0].clientY - start.y;
          if (Math.abs(dx) > 8 || Math.abs(dy) > 8) start.moved = true;
          if (scale > 1.01) {
            tx = start.tx + dx;
            ty = start.ty + dy;
            clampPan();
            apply(false);
          } else {
            // Follow the finger a little while swiping between images
            lbImg.style.transition = 'none';
            lbImg.style.transform = 'translateX(' + dx * 0.6 + 'px)';
          }
        }
      }, { passive: false });

      lbStage.addEventListener('touchend', function (e) {
        if (!start) return;
        var s0 = start;
        if (e.touches.length > 0) {
          // One finger lifted after a pinch: continue as a pan with the remaining finger
          var t = e.touches[0];
          start = { pinch: false, x: t.clientX, y: t.clientY, tx: tx, ty: ty, moved: true };
          return;
        }
        start = null;
        if (s0.pinch) {
          if (scale < 1.05) reset(true);
          return;
        }
        var c = e.changedTouches[0];
        var dx = c.clientX - s0.x;
        var dy = c.clientY - s0.y;

        if (!s0.moved) {
          // Double-tap toggles zoom (a single tap on the background closes via the click handler)
          var now = Date.now();
          if (now - lastTap < 300) {
            lastTap = 0;
            var p = stagePoint(c.clientX, c.clientY);
            if (scale > 1.01) reset(true);
            else zoomAt(CLICK_SCALE, p.x, p.y, true);
          } else {
            lastTap = now;
          }
          return;
        }

        if (scale <= 1.01) {
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
          else apply(true); // snap back
        }
      });
    }

    zoomWrap.addEventListener('click', open);
  }
})();

// ==================== CUSTOM ORDER ====================
(function () {
  'use strict';

  function EclatCustomOrder(container) {
    this.container        = container;
    this.sectionId        = container.dataset.sectionId;
    this.customVariantId  = container.dataset.customVariantId || '';
    this._isCustomMode    = false;
    this._savedVariantId  = null;

    this.prompt     = container.querySelector('.eclat-custom-order__prompt');
    this.customForm = container.querySelector('.eclat-custom-order__form');
    this.trigger    = container.querySelector('.eclat-custom-order__trigger');
    this.backBtn    = container.querySelector('.eclat-custom-order__back');
    this.shapeEl    = container.querySelector('.eclat-custom-shape');
    this.lengthEl   = container.querySelector('.eclat-custom-length');
    this.propShape  = container.querySelector('.eclat-prop-shape');
    this.propLength = container.querySelector('.eclat-prop-length');
    this.propFee    = container.querySelector('.eclat-prop-fee');
    this.variantContainer = document.getElementById('variant-selects-' + this.sectionId);
    this.productForm      = document.getElementById('product-form-' + this.sectionId);

    if (this.trigger) this.trigger.addEventListener('click',  this._enter.bind(this));
    if (this.backBtn) this.backBtn.addEventListener('click',  this._exit.bind(this));
    if (this.shapeEl)  this.shapeEl.addEventListener('change', this._sync.bind(this));
    if (this.lengthEl) this.lengthEl.addEventListener('change', this._sync.bind(this));
  }

  EclatCustomOrder.prototype._enter = function (e) {
    e.preventDefault();
    this._isCustomMode = true;

    // Save current variant before switching
    var idInput = this.productForm && this.productForm.querySelector('input[name="id"]');
    this._savedVariantId = idInput ? idInput.value : null;

    if (this.variantContainer) this.variantContainer.style.display = 'none';
    this.prompt.style.display = 'none';
    this.customForm.removeAttribute('hidden');
    this._setProps(false);
    this._sync();

    if (this.customVariantId) {
      this._setVariant(this.customVariantId);
    }
  };

  EclatCustomOrder.prototype._exit = function (e) {
    e.preventDefault();
    this._isCustomMode = false;
    if (this.variantContainer) this.variantContainer.style.display = '';
    this.prompt.style.display = '';
    this.customForm.setAttribute('hidden', '');
    this._setProps(true);

    // Restore original variant — trigger Dawn's own selector so price also restores
    if (this.variantContainer) {
      var checked = this.variantContainer.querySelector('input[type="radio"]:checked, select');
      if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (this._savedVariantId) {
      this._setVariant(this._savedVariantId);
    }
  };

  EclatCustomOrder.prototype._setVariant = function (variantId) {
    var idInput = this.productForm && this.productForm.querySelector('input[name="id"]');
    if (!idInput) return;
    idInput.value = variantId;
    // Ask Shopify to render the selected variant with the active market's
    // currency and the merchant's native money format.
    this._fetchAndUpdatePrice(variantId);
  };

  EclatCustomOrder.prototype._fetchAndUpdatePrice = function (variantId) {
    var productInfo = document.querySelector('product-info[data-section="' + this.sectionId + '"]');
    if (!productInfo) return;
    var productUrl = productInfo.dataset.url;
    if (!productUrl) return;

    var sectionId = this.sectionId;
    var requestUrl = new URL(productUrl, window.location.origin);
    requestUrl.searchParams.set('variant', variantId);
    requestUrl.searchParams.set('section_id', sectionId);

    fetch(requestUrl.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not render product price');
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var sourcePrice = html.getElementById('price-' + sectionId);
        var currentPrice = document.getElementById('price-' + sectionId);
        if (!sourcePrice || !currentPrice) return;
        currentPrice.innerHTML = sourcePrice.innerHTML;
        currentPrice.classList.toggle('hidden', sourcePrice.classList.contains('hidden'));
      })
      .catch(function () {
        // Keep the current server-rendered price if the section request fails.
      });
  };

  EclatCustomOrder.prototype._setProps = function (disabled) {
    [this.propShape, this.propLength, this.propFee].forEach(function (el) {
      if (el) el.disabled = disabled;
    });
  };

  EclatCustomOrder.prototype._sync = function () {
    if (this.propShape  && this.shapeEl)  this.propShape.value  = this.shapeEl.value;
    if (this.propLength && this.lengthEl) this.propLength.value = this.lengthEl.value;
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-eclat-custom-order]').forEach(function (el) {
      new EclatCustomOrder(el);
    });
  });
})();

/* ==================== BUY IT WITH — cart buttons ==================== */
(function () {
  function s(key) {
    return (window.eclatStrings && window.eclatStrings[key]) || '';
  }

  function biwAddToCart(btn) {
    var id = btn.dataset.variantId;
    if (!id) return;
    var prev = btn.textContent;
    var errorAlert = btn.parentElement.querySelector('.eclat-cart-error');
    if (window.eclatSetCartError) window.eclatSetCartError(errorAlert);
    btn.disabled = true;
    btn.textContent = s('adding');
    window.eclatAddToCart(id, 1)
      .then(function (cartResponse) {
        btn.textContent = s('added') + ' ✓';
        window.eclatRenderCart(cartResponse);
        setTimeout(function () { btn.textContent = prev; btn.disabled = false; }, 1800);
      })
      .catch(function (error) {
        if (window.eclatSetCartError) window.eclatSetCartError(errorAlert, error);
        btn.textContent = prev;
        btn.disabled = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.eclat-biw__card-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { biwAddToCart(btn); });
    });
  });
})();
